import { useLayoutContext } from "@context/layout";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import Breadcrumb from "@shared/components/breadcrumb";
import { useAccess } from "@templates/course/hooks/useAccess";
import { useNonAccess } from "@templates/course/hooks/useNonAccess";
import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FC } from "react";

const ProductPageBreadcrumb: FC = () => {
  const { breadcrumbRef } = useNonAccess();
  const {
    courseData: {
      product: { slug, title },
    },
  } = useAccess();
  const layoutData = useLayoutContext();
  const isAdmin = layoutData?.userData?.user?.isAdmin || false;
  const isMobile = useIsMobile(768);
  return (
    <div
      ref={breadcrumbRef}
      className={classNames(
        "w-full relative z-20 truncate",
        isAdmin && isMobile ? "mt-14" : "mt-0"
      )}
    >
      <Breadcrumb
        defaultPath={`/explore/${slug}`}
        customLabel={toFarsiNumber(title)}
        isFullWidthContainer
        containerClassName="px-4     xl:px-0 section-container mx-auto border-b-0"
      />
    </div>
  );
};

export default ProductPageBreadcrumb;
